<template>
  <div class="toggle pos-rel w60px w50px-mb" :class="state ? 'active' : ''" @click="toggle">
    <div class="draggable pos-abs bg-violet" :style="style"></div>
  </div>
</template>
<script>
export default {
  name: 'bh-toggle',
  props: {
    value: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      state: this.value
    }
  },
  computed: {
    style() {
      return {
        transform: this.state ? 'translateX(100%)' : 'translateX(-10%)'
      }
    }
  },
  methods: {
    toggle() {
      this.state = !this.state
      this.$emit('output', this.state)
    }
  }
}
</script>

<style scoped>
.toggle {
  height: 15px;
  background: #fff;
  border: 2px solid #abb1d9;
  border-radius: 200px;
  transition: background 0.6s;
}

.draggable {
  top: -5px;
  width: 20px;
  height: 20px;
  border-radius: 100%;
  box-shadow: 0px 3px 10px rgba(0, 0, 0, 0.6);
  transform: translateX(0%);
  transition: transform 0.05s ease-in-out;
}

.active {
  background: #abb1d9;
  transition: background 0.6s;
}
</style>
